import moment from 'moment';
import {
  GET_AGGR_REQUEST,
  GET_AGGR_SUCCESS,
  GET_AGGR_FAILURE,
  GET_AGGR_CACHED,
  SET_USER_IMPERSONATION,
  RELOAD_FILTERS,
} from '../action/actionTypes';

const initialState = {
  payload: {},
  error: null,
};

export default function aggr(state = initialState, action) {
  switch (action.type) {
    case GET_AGGR_REQUEST:
      return {
        ...state,
        isWaiting: true,
        payload: {
          ...state.payload,
          [action.payload.key]: { ...action.payload, isWaiting: true },
        },
        error: initialState.error,
      };
    case GET_AGGR_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          [action.payload.key]: { ...action.payload, lastRefresh: moment(), isWaiting: false },
        },
        isWaiting: false,
        error: initialState.error,
      };
    case GET_AGGR_FAILURE:
      return {
        ...state,
        error: action.error,
        isWaiting: false,
      };
    case GET_AGGR_CACHED:
      return {
        ...state,
        isWaiting: false,
        error: initialState.error,
      };
    case RELOAD_FILTERS:
      return initialState;
    case SET_USER_IMPERSONATION:
      return { ...initialState };
    default:
      return state;
  }
}
